import React from 'react'
// import { Layout } from '@brainstud/react-tbl/features/modals'
import { Page, PageContent, Icon, Heading, Text } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { ModalPopup } from '@brainstud/react-tbl/themes/pgw/v1/components/modals'
import styles from './QuizIncomplete.module.css'

const QuizIncomplete = props => (
  <ModalPopup {...props}>
    <Page name="ContentModal" style={{ position: 'relative' }}>
      <PageContent>
        <div className={styles.base}>
          <Heading h3 icon="alert">Let op!</Heading>

          <div className={styles.alert}>
            <Text>Je hebt <b>{props.data.total - props.data.current}</b> van de <b>{props.data.total}</b> vragen nog niet ingevuld. Ga terug en vul de {((props.data.total - props.data.current) > 1) ? 'vragen' : 'vraag'} alsnog in om je toets in te leveren.</Text>
          </div>
        </div>
      </PageContent>

      <a onClick={props.app.toggleModal} className="Modal-popup-close">
        <Icon name="close" />
      </a>
    </Page>
  </ModalPopup>
)

export default QuizIncomplete
